import { render, staticRenderFns } from "./TabAluminium.vue?vue&type=template&id=1d5dcba9&scoped=true&"
import script from "./TabAluminium.vue?vue&type=script&lang=js&"
export * from "./TabAluminium.vue?vue&type=script&lang=js&"
import style0 from "./TabAluminium.vue?vue&type=style&index=0&id=1d5dcba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dcba9",
  null
  
)

export default component.exports